import { BaseResource } from '../core/base-resource';
import { DeferChoice } from '../core/defer-choice.enum';

export class OrderDeferOptions extends BaseResource {
  selectedOption: DeferChoice;
  deferDate: string;
}
